exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.leo-knowledge-tip-popper {\r\n  max-width: 440px !important;\n}\n.leo-knowledge-tip-popper .leo-tip-rich {\r\n  line-height: 1.55;\r\n  word-break: break-word;\r\n  white-space: pre-wrap;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1843012a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/LeoKnowledge/LeoFormLabelTip.vue
// module id = nETt
// module chunks = 478